import { render } from "./AddFileResponse.vue?vue&type=template&id=77dc64ca&scoped=true"
import script from "./AddFileResponse.vue?vue&type=script&lang=js"
export * from "./AddFileResponse.vue?vue&type=script&lang=js"

import "./AddFileResponse.vue?vue&type=style&index=0&id=77dc64ca&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77dc64ca"]])

export default __exports__